<mat-card appearance="outlined">
  <mat-card-content>
    <div class="card-content">
      <div class="card-content__color">
        <div class="show-color">
          <div [ngStyle]="{ 'background-color': color?.color }" class="w-full min-h-[100px] max-w-[200px] rounded-lg"></div>
          <h3>{{ color?.id }}</h3>
          <span>{{ color?.name }}</span>
        </div>
      </div>

      <div class="card-content__description">
        <p>
          <b>{{ 'LabDipRequest_Brand' | translateWF: 'Brand' }}</b> &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span>{{ color?.brand }}</span>
        </p>
        <br />
        <br />
        <p>
          <b>{{ 'LabDipRequest_Customer' | translateWF: 'Customer' }}</b> &nbsp; <span>{{ color?.customer }}</span>
        </p>
      </div>
    </div>
  </mat-card-content>
</mat-card>
